import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Badge } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useNavigate } from 'react-router-dom';
import http from '../../commonFunctions/htttpClientNew'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import { useSnackbar } from '../Snackbar/SnackBarContext';
interface NavbarProps {
  toggleSidebar: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ toggleSidebar }) => {
  const navigate = useNavigate();
 const { showMessage } = useSnackbar();

  const handleLogout = () => {
    navigate('/logout');
  };
  const handlePayementSchedule=async()=>{
    try{
      const today = new Date();
      const response:any=await http.post('Bill/schedule-payments',today)
      if(response && response.message){
        showMessage(response.message,"success")
      }
    }
    catch(e){

    }
  }
  return (
    <AppBar position="static" sx={{ backgroundColor: 'transparent', color: 'black', boxShadow: 'none',border:'2px solid #fff' }}>
      <Toolbar sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleSidebar}  // Triggers sidebar toggle
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          ADMIN
        </Typography>
        {/* <IconButton color="inherit" aria-label="notifications" onClick={handlePayementSchedule}>
         
            <SyncOutlinedIcon  />
        
        </IconButton> */}
        <IconButton color="inherit" aria-label="logout"  onClick={handleLogout}>
          <ExitToAppIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};
//onClick={()=>{navigate('/logout')}}

export default Navbar;
